<template>
	<div class="topbar-container">
		<!-- Left Section -->
		<div class="topbar-left">
			<div class="humberger-menu web" @click="changeMenuStatus">
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M3 12H21M3 6H21M3 18H21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
			</div>
			<div class="humberger-menu mobile" @click="openMobileMenu">
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M3 12H21M3 6H21M3 18H21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
			</div>
			<!-- <div class="search-container">
				<svg class="search-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="11" cy="11" r="8" stroke="currentColor" stroke-width="2"/>
					<path d="m21 21-4.35-4.35" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
				<span class="search-text">جستجو...</span>
			</div> -->
		</div>

		<!-- Center Section -->
		<div class="topbar-center" @click='selectProject'>
			<span class="project-icon">
				<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
					<path d="M4 21V6a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v15"/>
					<path d="M15 9h3a2 2 0 0 1 2 2v10"/>
					<path d="M3 21h18"/>
					<path d="M8 8h2M8 12h2M8 16h2"/>
				</svg>
			</span>
			<div class="project-info">
				<div class="project-name">{{ projectName.project ? projectName.project.name_fa : 'انتخاب پروژه' }}</div>
				<div class="project-subtitle">تغییر پروژه</div>
			</div>
			<svg class="project-chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
				<polyline points="6 9 12 15 18 9"/>
			</svg>
		</div>

		<!-- Right Section -->
		<div class="topbar-right">
			<!-- <div class="notification-icon">
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					<path d="M13.73 21a2 2 0 0 1-3.46 0" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
				<div class="notification-badge">2</div>
			</div> -->
			
			<!-- <div class="settings-icon">
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2"/>
					<path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1 1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
			</div> -->

			<div class="user-section" @click.stop="showProfile = !showProfile">
				<div class="user-info">
					<div class="user-name">{{ projectName.user ? (projectName.user.first_name + ' ' + projectName.user.last_name) : '' }}</div>
					<div class="user-role">مدیر سیستم</div>
				</div>
				<div class="user-avatar">
					<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						<circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2"/>
					</svg>
				</div>
			</div>

			<div class="user-panel-dropdown" :class="{ 'show-profile': showProfile }" @click.stop>
				<div class="drop-down-item" @click="logout">
					<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						<polyline points="16,17 21,12 16,7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						<line x1="21" y1="12" x2="9" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>
					<span>خروج</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// import Button from '../components/Button/Button.vue';
export default {
	components: {
		// Button,
	},
	data() {
		return {
			priceData: null,
			showProfile: false,
			projectName:{}
		};
	},
	watch: {
		$route: function () {
			this.showProfile = false;
			// this.getExchange();
		},
	},
	created() {
		this.getProjectName();
		document.addEventListener('click', this.handleClickOutside);
	},
	beforeDestroy() {
		document.removeEventListener('click', this.handleClickOutside);
	},
	methods: {
		handleClickOutside(event) {
			const userSection = this.$el.querySelector('.user-section');
			const dropdown = this.$el.querySelector('.user-panel-dropdown');
			
			if (userSection && dropdown && this.showProfile) {
				if (!userSection.contains(event.target) && !dropdown.contains(event.target)) {
					this.showProfile = false;
				}
			}
		},
		changeMenuStatus() {
			this.$STORE.commit('appConfig/changeMenuStatus', !this.$STORE.state.appConfig.closeMenu);
		},
		openMobileMenu() {
			this.$STORE.commit('appConfig/openMenuMobile', !this.$STORE.state.appConfig.mobileMobile);
		},
		async getProjectName() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.ACTIVE_PROJECT +
					this.$STORE.state.userConfig.setProjectId +
					'/' +'?p=' + this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.ORDER,
			);
			if (res.status === 200) {
				this.projectName = res.data;
				(this.projectName);
			}
		},
		goToOrder() {
			this.$router.push({ name: 'addOrder' });
		},
		selectProject() {
			this.$router.push({ name: 'projects' });
		},
		logout() {
			this.$STORE.commit('userConfig/clearAllConfigs');
			this.$router.push({ name: 'login' });
		},
	},
};
</script>

<style lang="scss" scoped>
.topbar-container {
	height: 80px;
	width: 100%;
	background: linear-gradient(180deg, #223047 0%, #1a2332 100%);
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0 32px;
	box-shadow: 0 4px 24px rgba(3, 6, 12, 0.28);
	position: relative;
	z-index: 1000;
	border-bottom: 1px solid rgba(255, 255, 255, 0.08);

	&::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background:
			radial-gradient(60% 140% at 0% 0%, rgba(58, 166, 166, 0.12), transparent 60%),
			radial-gradient(60% 140% at 100% 0%, rgba(45, 139, 139, 0.12), transparent 60%);
		pointer-events: none;
	}
}

/* Left Section */
.topbar-left {
	display: flex;
	align-items: center;
	gap: 24px;
	z-index: 1;

	.humberger-menu {
		cursor: pointer;
		transition: all 0.3s ease;
		padding: 8px;
		border-radius: 8px;
		color: #e2e8f0;

		&:hover {
			background: rgba(255, 255, 255, 0.1);
			color: #ffffff;
			transform: scale(1.05);
		}
	}

	.search-container {
		display: flex;
		align-items: center;
		gap: 12px;
		padding: 8px 16px;
		background: rgba(255, 255, 255, 0.05);
		border: 1px solid rgba(255, 255, 255, 0.1);
		border-radius: 12px;
		backdrop-filter: blur(10px);
		transition: all 0.3s ease;
		cursor: pointer;

		&:hover {
			background: rgba(255, 255, 255, 0.1);
			border-color: rgba(255, 255, 255, 0.2);
		}

		.search-icon {
			color: #9ca3af;
			transition: color 0.3s ease;
		}

		.search-text {
			color: #9ca3af;
			font-size: 14px;
			font-weight: 400;
			transition: color 0.3s ease;
		}

		&:hover .search-icon,
		&:hover .search-text {
			color: #e2e8f0;
		}
	}
}

/* Center Section */
.topbar-center {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 11px;
	z-index: 1;
	cursor: pointer;
	transition: all 0.25s ease;
	padding: 7px 14px;
	border-radius: 12px;
	border: 1px solid rgba(255, 255, 255, 0.08);

	&:hover {
		background: rgba(255, 255, 255, 0.06);
		border-color: rgba(58, 166, 166, 0.35);

		.project-chevron {
			color: #3aa6a6;
			transform: translateY(1px);
		}
	}

	.project-icon {
		width: 38px;
		height: 38px;
		flex-shrink: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 10px;
		color: #3aa6a6;
		background: rgba(58, 166, 166, 0.12);
	}

	.project-chevron {
		color: #7f8ea8;
		flex-shrink: 0;
		transition: all 0.25s ease;
	}

	.project-info {
		text-align: right;

		.project-name {
			color: #ffffff;
			font-size: 18px;
			font-weight: 600;
			margin: 0;
			line-height: 1.2;
		}

		.project-subtitle {
			color: #9ca3af;
			font-size: 12px;
			font-weight: 400;
			margin: 0;
			margin-top: 2px;
		}
	}
}

/* Right Section */
.topbar-right {
	display: flex;
	align-items: center;
	gap: 20px;
	z-index: 1;

	.notification-icon {
		position: relative;
		cursor: pointer;
		padding: 8px;
		border-radius: 8px;
		transition: all 0.3s ease;
		color: #e2e8f0;

		&:hover {
			background: rgba(255, 255, 255, 0.1);
			color: #ffffff;
			transform: scale(1.05);
		}

		.notification-badge {
			position: absolute;
			top: 4px;
			right: 4px;
			background: #ef4444;
			color: white;
			font-size: 10px;
			font-weight: 600;
			width: 16px;
			height: 16px;
			border-radius: 50%;
			display: flex;
			align-items: center;
			justify-content: center;
			border: 2px solid #2d3748;
		}
	}

	.settings-icon {
		cursor: pointer;
		padding: 8px;
		border-radius: 8px;
		transition: all 0.3s ease;
		color: #e2e8f0;

		&:hover {
			background: rgba(255, 255, 255, 0.1);
			color: #ffffff;
			transform: scale(1.05);
		}
	}

	.user-section {
		display: flex;
		align-items: center;
		gap: 12px;
		cursor: pointer;
		padding: 8px 12px;
		border-radius: 12px;
		transition: all 0.3s ease;
		border: 1px solid rgba(255, 255, 255, 0.1);

		&:hover {
			background: rgba(255, 255, 255, 0.05);
			border-color: rgba(255, 255, 255, 0.2);
		}

		.user-info {
			text-align: right;

			.user-name {
				color: #ffffff;
				font-size: 14px;
				font-weight: 600;
				margin: 0;
				line-height: 1.2;
			}

			.user-role {
				color: #9ca3af;
				font-size: 12px;
				font-weight: 400;
				margin: 0;
				margin-top: 2px;
			}
		}

		.user-avatar {
			width: 40px;
			height: 40px;
			background: rgba(255, 255, 255, 0.1);
			border-radius: 50%;
			display: flex;
			align-items: center;
			justify-content: center;
			color: #e2e8f0;
			transition: all 0.3s ease;

			&:hover {
				background: rgba(255, 255, 255, 0.2);
				color: #ffffff;
			}
		}
	}

	.user-panel-dropdown {
		position: absolute;
		top: 100%;
		left: 32px;
		width: 200px;
		background: rgba(45, 55, 72, 0.95);
		backdrop-filter: blur(20px);
		border: 1px solid rgba(255, 255, 255, 0.1);
		border-radius: 16px;
		padding: 16px;
		box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
		opacity: 0;
		visibility: hidden;
		transform: translateY(-10px);
		transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
		z-index: 9999;

		.drop-down-item {
			display: flex;
			align-items: center;
			gap: 12px;
			padding: 12px;
			border-radius: 8px;
			cursor: pointer;
			transition: all 0.3s ease;
			color: #e2e8f0;

			&:hover {
				background: rgba(255, 255, 255, 0.1);
				color: #ffffff;
				transform: translateX(-4px);
			}

			svg {
				transition: transform 0.3s ease;
			}

			&:hover svg {
				transform: scale(1.1);
			}

			span {
				font-size: 14px;
				font-weight: 500;
			}
		}

		&.show-profile {
			opacity: 1;
			visibility: visible;
			transform: translateY(0);
		}
	}
}

/* Responsive Design */
.web {
	@media screen and (max-width: 767px) {
		display: none;
	}
}

.mobile {
	@media screen and (min-width: 768px) {
		display: none;
	}
}

@media (max-width: 768px) {
	.topbar-container {
		padding: 0 16px;
		height: 70px;
	}

	.topbar-left {
		gap: 16px;

		.search-container {
			display: none;
		}
	}

	.topbar-center {
		.project-info {
			.project-name {
				font-size: 16px;
			}
		}
	}

	.topbar-right {
		gap: 12px;

		.user-section {
			.user-info {
				display: none;
			}
		}
	}
}
</style>
